<small-card [smallCardData]="cardInfo.card"></small-card>
